import { css, keyframes } from "styled-components";
import { duration, easing } from "./transitions";

/** How long a closing dialog or drawer stays mounted so its exit plays (matches `duration.normal`). */
export const OVERLAY_EXIT_MS = 250;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;
const riseIn = keyframes`
  from { opacity: 0; transform: translateY(0.5rem) scale(0.98); }
  to { opacity: 1; transform: none; }
`;
const riseOut = keyframes`
  from { opacity: 1; transform: none; }
  to { opacity: 0; transform: translateY(0.5rem) scale(0.98); }
`;
const slideIn = keyframes`
  from { transform: translateX(-100%); }
  to { transform: none; }
`;
const slideOut = keyframes`
  from { transform: none; }
  to { transform: translateX(-100%); }
`;

const run = (name: ReturnType<typeof keyframes>, easingCurve: string) => css`
  animation: ${name} ${duration.normal} ${easingCurve} both;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/** A scrim or backdrop fading in and out. Pass `closing` while the exit plays (see `usePresence`). */
export const scrimMotion = (closing = false) => run(closing ? fadeOut : fadeIn, easing.smooth);

/** A dialog panel: fade plus a small rise and scale. Pass `closing` while the exit plays. */
export const dialogMotion = (closing = false) => css`
  ${run(closing ? riseOut : riseIn, easing.slideIn)}
  pointer-events: ${closing ? "none" : "auto"};
`;

/** A drawer sliding in from the left edge and back out. Pass `closing` while the exit plays. */
export const drawerSlideMotion = (closing = false) => css`
  ${run(closing ? slideOut : slideIn, easing.slideIn)}
  pointer-events: ${closing ? "none" : "auto"};
`;
